import { useEffect, useState } from 'react';
import syncManager from '@mm/state/syncEngine/services/SyncManager';

export const useSyncManager = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const registerOnStartProcessing = syncManager.registerOnStartProcessing(
      () => setIsProcessing(true),
    );
    const registerOnFinishProcessing = syncManager.registerOnFinishProcessing(
      () => setIsProcessing(false),
    );

    return () => {
      registerOnStartProcessing();
      registerOnFinishProcessing();
    };
  }, []);

  return {
    isProcessing,
  };
};
